module.exports = __webpack_public_path__ + "media/images/whatsapp-959410f6066ef99a1225d2f039262a79.png";